import { useModuleBEM } from "@b2bportal/core-themes";
import type { PlatformComponentProps } from "@b2bportal/core-types";
import { useI18nContext } from "@hopper-b2b/i18n";
import {
  CarDateRangePicker,
  useCarsAvailabilityFilters,
  useCarSearch,
} from "@tenant/cars";
import { Button, ButtonTypeEnum } from "@tenant/ui";
import clsx from "clsx";
import defaultStyles from "./CarListNoItems.module.scss";
import CarIllustration from "@/assets/images/car.svg?react";
import { useCarsStyles } from "~core-cars/themes";
import { CoreCarsComponent } from "~core-cars/types";

export type CarsListNoItemsProps = {
  hasFilters: boolean;
} & PlatformComponentProps;
const COMPONENT_KEY = CoreCarsComponent.CarsListNoItems;

export const CarsListNoItems = ({
  className,
  hasFilters,
}: CarsListNoItemsProps) => {
  const styles = useCarsStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const { t } = useI18nContext();

  const { context, handlers } = useCarSearch({});
  const { handlers: filterHandlers } = useCarsAvailabilityFilters();

  return (
    <div className={clsx(block, className)}>
      <CarIllustration aria-hidden="true" />
      <h2 className={cn("title")}>{t("core-cars.noCarsFound")}</h2>
      <p className={cn("subtitle")}>{t("core-cars.noResults.description")}</p>
      <div className={cn("actions")}>
        <CarDateRangePicker
          startDate={context.pickupDate}
          endDate={context.dropoffDate}
          onStartDateChangeHandler={handlers.handlePickupDateChange}
          onEndDateChangeHandler={handlers.handleDropoffDateChange}
          triggerButton={
            <Button
              className={cn("change-dates-button")}
              buttonType={ButtonTypeEnum.Primary}
            >
              {t("changeDates")}
            </Button>
          }
        />

        {hasFilters && (
          <Button
            className={cn("reset-filters-button")}
            buttonType={ButtonTypeEnum.Primary}
            onClick={filterHandlers.resetFilters}
          >
            {t("core-cars.availabilityPage.warning.resetFilter")}
          </Button>
        )}
      </div>
    </div>
  );
};
